import React from 'react';
import { ArrowRight } from 'lucide-react';
import { FadeIn } from './ui/FadeIn';
import { TOURS_HASH } from '../hooks/useHashRoute';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20" data-id="element-84" data-mp="ei1vtn9me4yh">
      {/* Background Image & Overlays */}
      <div className="absolute inset-0 z-0" data-id="element-85" data-mp="4mrvd3yve5mt">
        <img src="https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?q=80&w=2075&auto=format&fit=crop" alt="Luxury apartment interior" className="w-full h-full object-cover opacity-40" data-id="element-86" data-mp="4jvvvb7dj8w9" />
        <div className="absolute inset-0 bg-gradient-to-b from-zinc-950/40 via-zinc-950/80 to-zinc-950" data-id="element-87" data-mp="sartioyigybf" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(255,255,255,0.03)_0%,transparent_100%)]" data-id="element-88" data-mp="nczt16jsw3vm" />
      </div>

      <div className="relative z-20 max-w-7xl mx-auto px-6 w-full flex flex-col items-center text-center" data-id="element-89" data-mp="3d2tnz8hi2ie0">
        {/* Live Indicator */}
        <FadeIn delay={0.1} data-id="element-90" data-mp="3j8se7xjcfdo9">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full glass-panel mb-8" data-id="element-91" data-mp="3j9k9t8cxxbej">
            <span className="relative flex h-2 w-2" data-id="element-92" data-mp="3o6ki7px9iq8t">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-white opacity-75" data-id="element-93" data-mp="3o59ajf0p4ycf"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-white" data-id="element-94" data-mp="3e8wl4tc6p6nh"></span>
            </span>
            <span className="text-xs font-medium tracking-wide uppercase text-zinc-300" data-id="element-95" data-mp="30hhsrvwdzt3r">
              Immersive 360° Experience
            </span>
          </div>
        </FadeIn>

        {/* Headlines */}
        <FadeIn delay={0.2} data-id="element-96" data-mp="2qkmu9d045sph">
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-display font-semibold tracking-tighter text-gradient mb-6 max-w-5xl mx-auto leading-[1.1]" data-id="element-97" data-mp="2qlepuntpnqfr">
            Explore Properties Before You Visit
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-98" data-mp="2lkqyg11kl7l0">
          <p className="text-lg md:text-xl text-zinc-400 max-w-3xl mx-auto leading-relaxed font-light" data-id="element-99" data-mp="2ll0g91cgo8fm">
            MUNISVerse provides immersive virtual property tours and inspections
            for buyers, tenants, developers, corporates, and real estate
            professionals.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-100" data-mp="id03goyxw2nl">
          <a href={TOURS_HASH} onClick={e => {
          e.preventDefault();
          window.location.hash = TOURS_HASH;
        }} className="relative mt-10 inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium rounded-full bg-white text-zinc-950 hover:bg-zinc-200 transition-colors duration-200 whitespace-nowrap focus:outline-none focus:ring-2 focus:ring-white/20" data-id="element-101" data-mp="ia5jeyju8jup">
            Explore virtual tours
            <ArrowRight size={16} data-id="element-102" data-mp="x0cs4mk1moi7" />
          </a>
        </FadeIn>
      </div>

      {/* Bottom Gradient Fade */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-zinc-950 to-transparent z-10 pointer-events-none" data-id="element-103" data-mp="3lui6mj3rolho" />
    </section>;
}